import CollectConditions from '@components/app/TrialApply/CollectConditions.client'
import CollectDateOfBirth from '@components/app/TrialApply/CollectDateOfBirth.client'
import CollectGenderIdentities from '@components/app/TrialApply/CollectGenderIdentities.client'
import CollectHeight from '@components/app/TrialApply/CollectHeight.client'
import CollectName from '@components/app/TrialApply/CollectName.client'
import CollectPhoneNumber from '@components/app/TrialApply/CollectPhoneNumber.client'
import CollectRaceEthnicityIdentities from '@components/app/TrialApply/CollectRaceEthnicityIdentities.client'
import CollectWeight from '@components/app/TrialApply/CollectWeight.client'
import CollectZipcode from '@components/app/TrialApply/CollectZipcode.client'
import { shouldSkipQuestionForPatient } from '@components/hooks/PatientTrialApplySurveyProvider/shouldSkipQuestionForPatient'
import type {
  DemographicsSurveyQuestion,
  ShouldSkipQuestionForPatientProps,
} from './types'

export type DemographicAttributesType = keyof typeof DemographicAttributes

export const DemographicAttributes = {
  conditions: 'conditions' as const,
  dateOfBirth: 'dateOfBirth' as const,
  email: 'email' as const,
  ethnicIdentities: 'ethnicIdentities' as const,
  genderIdentities: 'genderIdentities' as const,
  heightInCm: 'heightInCm' as const,
  name: 'name' as const,
  phoneNumber: 'phoneNumber' as const,
  weightInKg: 'weightInKg' as const,
  zipcode: 'zipcode' as const,
}

export const SurveyQuestionsDemographics: DemographicsSurveyQuestion[] = [
  {
    category: 'demographics',
    component: CollectName,
    id: DemographicAttributes.name,
    questionText: 'What is your full legal name?',
    shouldSkipQuestionForPatient: ({
      isSignupFlow = false,
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      isSignupFlow
        ? Promise.resolve(true)
        : shouldSkipQuestionForPatient({
            attribute: DemographicAttributes.name,
            patientProfileData,
          }),
  },
  {
    category: 'demographics',
    component: CollectConditions,
    id: DemographicAttributes.conditions,
    questionText: 'Which conditions do you have?',
    shouldSkipQuestionForPatient: ({
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      shouldSkipQuestionForPatient({
        attribute: DemographicAttributes.conditions,
        patientProfileData,
      }),
  },
  {
    category: 'demographics',
    component: CollectPhoneNumber,
    id: DemographicAttributes.phoneNumber,
    questionText:
      'What phone number can the recruitment coordinator reach you?',
    shouldSkipQuestionForPatient: ({
      isSignupFlow = false,
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      isSignupFlow
        ? Promise.resolve(true)
        : shouldSkipQuestionForPatient({
            attribute: DemographicAttributes.phoneNumber,
            patientProfileData,
          }),
  },
  {
    category: 'demographics',
    component: CollectDateOfBirth,
    id: DemographicAttributes.dateOfBirth,
    questionText: 'When were you born?',
    shouldSkipQuestionForPatient: ({
      isSignupFlow = false,
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      isSignupFlow
        ? Promise.resolve(true)
        : shouldSkipQuestionForPatient({
            attribute: DemographicAttributes.dateOfBirth,
            patientProfileData,
          }),
  },
  {
    category: 'demographics',
    component: CollectGenderIdentities,
    id: DemographicAttributes.genderIdentities,
    questionText: 'Which gender expressions do you identify with?',
    shouldSkipQuestionForPatient: ({
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      shouldSkipQuestionForPatient({
        attribute: DemographicAttributes.genderIdentities,
        patientProfileData,
      }),
  },
  {
    category: 'demographics',
    component: CollectRaceEthnicityIdentities,
    id: DemographicAttributes.ethnicIdentities,
    questionText: 'Which races or ethnicities do you most identify with?',
    shouldSkipQuestionForPatient: ({
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      shouldSkipQuestionForPatient({
        attribute: DemographicAttributes.ethnicIdentities,
        patientProfileData,
      }),
  },
  {
    category: 'demographics',
    component: CollectHeight,
    id: DemographicAttributes.heightInCm,
    questionText: 'How tall are you?',
    shouldSkipQuestionForPatient: ({
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      shouldSkipQuestionForPatient({
        attribute: DemographicAttributes.heightInCm,
        patientProfileData,
      }),
    skippable: true,
  },
  {
    category: 'demographics',
    component: CollectWeight,
    id: DemographicAttributes.weightInKg,
    questionText: 'How much do you weigh?',
    shouldSkipQuestionForPatient: ({
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      shouldSkipQuestionForPatient({
        attribute: DemographicAttributes.weightInKg,
        patientProfileData,
      }),
    skippable: true,
  },
  {
    category: 'demographics',
    component: CollectZipcode,
    id: DemographicAttributes.zipcode,
    questionText: 'What is your zipcode?',
    shouldSkipQuestionForPatient: ({
      patientProfileData,
    }: ShouldSkipQuestionForPatientProps) =>
      shouldSkipQuestionForPatient({
        attribute: DemographicAttributes.zipcode,
        patientProfileData,
      }),
  },
]
